import React from 'react'
export const DashboardPage = React.lazy(() => import('./dashboard.page'))
